import React, { Component } from 'react';
import {withRouter} from 'react-router-dom';
import Loading from '../../hoc/Loading/Loading';
import axios from '../../axios';
// import Plot from "react-plotly.js";
import { connect } from 'react-redux'; 
import { skills_levels } from '../../utils/constants';
import Plot from "../../utils/customPlotly";


class PlotlyChart extends Component {
    constructor(props) {
        super(props);
        this.state = {
          data:null,
          title:null,
          width:this.props.width?this.props.width:250,
          height:this.props.height?this.props.height:250,
          chartType:null,
          theta_data:this.props.theta_data
         }
    }
 
    componentDidUpdate(prevState, prevProps){
      let{data}=this.props
      if(prevState.theta_data.length!=this.props.theta_data.length){
        this.setState({data})
      }
    }

    componentDidMount(){
       this.setState({
          data:this.props.data,
          title:this.props.title,
          width:this.props.width?this.props.width:500,
          height:this.props.height?this.props.height:400,
          chartType:this.props.chartType?this.props.chartType:null
        })
    }
 


    renderPlot=()=>{
      let{title, width, height, data, chartType}=this.state
      let max_range = skills_levels[skills_levels.length-1].id

        return(<Plot
          data={data}
          layout={{
            width,
            height,
            title,
            autosize: false,
            polar: chartType == 'polar'? {
                radialaxis: {
                  // visible: true,
                  range: [0, max_range ]   
                },angularaxis: {
                  direction: "clockwise",
                  period: 8
                }
              }:null,
            showlegend: true,
            legend: {
              orientation: "h",
              x: 0,
              y: -0.1, 
            }
          }}
        />)
      
    }


      render() {
       
        return this.renderPlot()
        // if(chartType && data && data.length>0){
        //   return this.renderPlot()
        // }  
    }
}



const mapStateToProps = state => {
    return {
    
    }
  }
  
  const mapDispatchToProps = dispatch => {
    return {
     
    }
  }


export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Loading(PlotlyChart, axios)));